/*
 * Wybór wariantu produktu promocyjnego w wierszu „Kup X, otrzymaj Y”
 * (snippets/promocja-gratis.liquid). Ceny, zdjęcia i id wariantów są
 * policzone w Liquidzie (JSON data-promocja-dane) - tu tylko podmieniamy
 * id w formularzu, cenę, zdjęcie i napis przycisku po kliknięciu opcji.
 */
(function () {
  function init(karta) {
    if (karta.dataset.promocjaInit) return;
    karta.dataset.promocjaInit = '1';

    var dane;
    try {
      dane = JSON.parse(karta.querySelector('[data-promocja-dane]').textContent);
    } catch (e) {
      return;
    }

    var przyciski = karta.querySelectorAll('.promocja__wartosc');
    var input = karta.querySelector('input[name="id"]');
    var submit = karta.querySelector('.promocja__przycisk');
    var napis = karta.querySelector('[data-promocja-przycisk]');
    var cenaPo = karta.querySelector('.promocja__cena-po');
    var cenaPrzed = karta.querySelector('.promocja__cena-przed');
    var osz = karta.querySelector('.promocja__oszczedzasz');
    var tytul = karta.querySelector('[data-promocja-tytul]');
    var img = karta.querySelector('.promocja__foto img');

    function wybrane() {
      var w = [];
      przyciski.forEach(function (b) {
        if (b.getAttribute('aria-pressed') === 'true') w[+b.dataset.opcja] = b.dataset.wartosc;
      });
      return w;
    }

    function znajdz(opcje) {
      for (var i = 0; i < dane.length; i++) {
        var ok = true;
        for (var j = 0; j < opcje.length; j++) {
          if (dane[i].opcje[j] !== opcje[j]) { ok = false; break; }
        }
        if (ok) return dane[i];
      }
      return null;
    }

    // Wartości bez dostępnego wariantu przy pozostałych wybranych opcjach - przygaszone
    function oznaczDostepne(opcje) {
      przyciski.forEach(function (b) {
        var test = opcje.slice();
        test[+b.dataset.opcja] = b.dataset.wartosc;
        var v = znajdz(test);
        b.classList.toggle('jest-niedostepna', !v || !v.dostepny);
      });
    }

    function pokaz() {
      var opcje = wybrane();
      var v = znajdz(opcje);
      oznaczDostepne(opcje);
      if (!v) return;

      input.value = v.id;
      cenaPo.textContent = v.po;
      cenaPrzed.textContent = v.przed;
      osz.textContent = osz.textContent.charAt(0) + v.osz;
      if (tytul) tytul.textContent = v.tytul;
      if (img && v.foto) {
        img.removeAttribute('srcset');
        img.src = v.foto;
      }
      submit.disabled = !v.dostepny;
      napis.textContent = v.dostepny ? napis.dataset.prefiks + v.po : 'Wariant niedostępny';
    }

    przyciski.forEach(function (b) {
      b.addEventListener('click', function () {
        karta.querySelectorAll('.promocja__wartosc[data-opcja="' + b.dataset.opcja + '"]').forEach(function (x) {
          x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
        });
        pokaz();
      });
    });

    oznaczDostepne(wybrane());
  }

  function wszystkie() {
    document.querySelectorAll('[data-promocja-warianty]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wszystkie);
  } else {
    wszystkie();
  }
  document.addEventListener('shopify:section:load', wszystkie);
})();
